<template>
  <svg
    width="15px"
    height="16px"
    viewBox="0 0 15 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>box</title>
    <g
      id="Activity-Monitor"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1499.000000, -307.000000)"
        fill="#006F72"
        fill-rule="nonzero"
        id="Activity-Stream"
      >
        <g transform="translate(1467.000000, 0.000000)">
          <g
            id="Group-26"
            transform="translate(20.000000, 295.204545)"
          >
            <g
              id="Icon"
              transform="translate(0.000000, 0.750000)"
            >
              <g
                id="box"
                transform="translate(12.000000, 12.000000)"
              >
                <path
                  d="M7.50001667,3.70073519e-16 C6.88001804,3.70073519e-16 6.24835278,0.119158069 5.75499554,0.364990856 L0.468332293,2.99498501 C0.150832998,3.16831796 0,3.44832567 0,3.74999167 L0,9.94829456 C0,10.9491257 0.6900068,12.0532899 1.58833814,12.4999556 L5.96335341,14.6616174 C6.83835147,15.0957831 8.16168186,15.0966165 9.03667992,14.6616174 L13.4116702,12.4999556 C14.3175015,12.0499566 15,10.957459 15,9.94829456 L15,3.74999167 C15,3.44832567 14.8475003,3.14331801 14.5316677,2.99498501 L9.24501279,0.364990856 C8.75168055,0.119158069 8.12001529,3.70073519e-16 7.50001667,3.70073519e-16 Z M6.51001887,1.84916256 C7.03001771,1.5908298 7.97001562,1.5908298 8.49001447,1.84916256 L12.2916727,3.74999167 L8.49001447,5.6249875 C7.97001562,5.88330359 7.03001771,5.88330359 6.51001887,5.6249875 C6.45168566,5.5958209 3.26165942,4.02499106 2.70832731,3.74999167 L6.51001887,1.84916256 Z M1.66666296,5.10415532 C2.43499459,5.48665447 3.07749316,5.78664547 3.90665799,6.19830289 C4.59582312,6.5399688 5.51916274,6.99996778 5.75499554,7.1091342 C6.11668641,7.27663383 6.35585254,7.36080031 6.66668519,7.42163351 L6.66668519,13.1507874 L2.31750318,10.9899589 C1.98583725,10.8249593 1.66666296,10.3141271 1.66666296,9.94829456 L1.66666296,5.10415532 Z M13.333337,5.10415532 L13.333337,9.94829456 C13.333337,10.3224604 12.9958378,10.8466259 12.6566719,11.0157922 L8.33334815,13.1507874 L8.33334815,7.42163351 C8.64418079,7.36080031 8.96168009,7.26330053 9.21834618,7.13496748 L13.333337,5.10415532 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
